module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    on: {
      "click": function($event) {
        return _vm.watchVideo(_vm.videoLecture.id)
      }
    }
  }, [_c('div', {
    staticClass: "card-img-container"
  }, [(_vm.videoPicture) ? _c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": _vm.videoPicture
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-img-info"
  }, [_vm._v(_vm._s(_vm.videoDuration))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.videoTitle))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-1"
  }, [_vm._v(_vm._s(_vm.videoPublisher))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-2"
  }, [_vm._v(_vm._s(_vm.videoGrade) + " " + _vm._s(_vm.videoSubjectName))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-3"
  }, [_vm._v(_vm._s(_vm.$t('common.view_count')) + " " + _vm._s(_vm.getFormatCount(_vm.videoViewsCount)))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-4"
  }, [_vm._v(_vm._s(_vm.$t('common.like_up')) + " " + _vm._s(_vm.getFormatCount(_vm.videoLikesCount)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-398e7239","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoCard.vue
// module id = 1567
// module chunks = 1